"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edition = void 0;
/**
 * Class representing the Edition resource with helper functions.
 * An Edition is the main way of scheduling content to be published on a specific date.
 */
var Edition = /** @class */ (function () {
    /**
     * Creates a new Edition instance.
     * @param data JSON representation of the Edition model
     */
    function Edition(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    /**
     * Date when the edition should begin
     */
    Edition.prototype.getStartDate = function () {
        return new Date(this.start);
    };
    /**
     * Date when the edition should end
     */
    Edition.prototype.getEndDate = function () {
        return new Date(this.end);
    };
    /**
     * Export to JSON
     */
    Edition.prototype.toJSON = function () {
        return {
            id: this.id,
            start: this.start,
            end: this.end,
        };
    };
    return Edition;
}());
exports.Edition = Edition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRpdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9tb2RlbC9FZGl0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7R0FHRztBQUNIO0lBZ0JFOzs7T0FHRztJQUNILGlCQUFZLElBQVU7UUFDcEIsSUFBSSxJQUFJLEVBQUU7WUFDUixNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztTQUMzQjtJQUNILENBQUM7SUFFRDs7T0FFRztJQUNILDhCQUFZLEdBQVo7UUFDRSxPQUFPLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM5QixDQUFDO0lBRUQ7O09BRUc7SUFDSCw0QkFBVSxHQUFWO1FBQ0UsT0FBTyxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDNUIsQ0FBQztJQUVEOztPQUVHO0lBQ0gsd0JBQU0sR0FBTjtRQUNFLE9BQU87WUFDTCxFQUFFLEVBQUUsSUFBSSxDQUFDLEVBQUU7WUFDWCxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsR0FBRyxFQUFFLElBQUksQ0FBQyxHQUFHO1NBQ2QsQ0FBQztJQUNKLENBQUM7SUFDSCxjQUFDO0FBQUQsQ0FBQyxBQWxERCxJQWtEQztBQWxEWSwwQkFBTyJ9